import { jsx as _jsx } from "preact/jsx-runtime";
import { useRouteError } from 'react-router';
import '@etchteam/diamond-ui/canvas/Section/Section';
import '@/components/composition/Wrap/Wrap';
import ErrorPage from '@/components/template/ErrorPage/ErrorPage';
import { captureException } from '@/lib/sentry';
import StartLayout from '@/pages/start.layout';
/**
 * Global app error boundary
 */
export default function GlobalErrorPage() {
    const error = useRouteError();
    captureException(error, { route: 'Global error boundary' });
    return (_jsx(StartLayout, { children: _jsx("locator-wrap", { children: _jsx("diamond-section", { padding: "lg", children: _jsx(ErrorPage, {}) }) }) }));
}
